import { defineMessages } from 'react-intl';

export default defineMessages({
  errorMessage: {
    id: 'frontbucket.pullrequest.pendingReviewWarning.errorMessage',
    description: 'Text for warning flag about a pending review.',
    defaultMessage:
      "You can continue your review. You will only be able to approve or leave comments. Any tasks you've created will not be submitted.",
  },
  mergedTitle: {
    id: 'frontbucket.pullrequest.pendingReviewWarning.mergedTitle',
    description:
      'Title for warning flag about a pending review on a merged PR.',
    defaultMessage: 'This pull request has been merged',
  },
  declinedTitle: {
    id: 'frontbucket.pullrequest.pendingReviewWarning.declinedTitle',
    description:
      'Title for warning flag about a pending review on a declined PR.',
    defaultMessage: 'This pull request has been declined',
  },
  closedTitle: {
    id: 'frontbucket.pullrequest.pendingReviewWarning.closedTitle',
    description:
      'Title for warning flag about a pending review on a closed PR.',
    defaultMessage: 'This pull request has been closed',
  },
  ok: {
    id: 'frontbucket.pullrequest.pendingReviewWarning.ok',
    description: 'OK button for warning flag about a pending review.',
    defaultMessage: 'OK',
  },
});
